export const styles = {
  header: {
    mb: 2,
  },
};
